import { app } from './chunk-ABZ5OBXE.mjs';
import { getFirestore } from 'firebase/firestore';

var firestore = getFirestore(app);

export { firestore };
//# sourceMappingURL=chunk-CBPAVK33.mjs.map
//# sourceMappingURL=chunk-CBPAVK33.mjs.map